import './style.scss';

const StorySkeleton = () => {
  return (
    <div className="story-skeleton">
      <p className="story-skeleton-text">Previewing stories requires a token</p>
      <div className="story-skeleton-story">
        <div className="story-skeleton-story-circle"></div>
        <div className="story-skeleton-story-bar"></div>
      </div>
      <div className="story-skeleton-story">
        <div className="story-skeleton-story-circle"></div>
        <div className="story-skeleton-story-bar"></div>
      </div>
      <div className="story-skeleton-story">
        <div className="story-skeleton-story-circle"></div>
        <div className="story-skeleton-story-bar"></div>
      </div>
      <div className="story-skeleton-story">
        <div className="story-skeleton-story-circle"></div>
        <div className="story-skeleton-story-bar"></div>
      </div>
      <div className="story-skeleton-story">
        <div className="story-skeleton-story-circle"></div>
        <div className="story-skeleton-story-bar"></div>
      </div>
    </div>
  );
};

export default StorySkeleton;
